import { InstallationAPI, InstallationStatus } from '@imunify360-api/installation';
import { Injectable } from '@angular/core';
import { XHR } from 'app/utils/xhr/xhr';
import { ExtendedRequestParams, DataFrom, AgentResponse } from '@imunify360-api/misc';

@Injectable({
    providedIn: 'root',
})
export class InstallationBackendService {
    constructor(public xhr: XHR) {}

    status = this.xhr.rx(InstallationAPI.status);
    start = this.xhr.request(InstallationAPI.start);

    upgradeStatus({offset, limit}: {offset: number, limit: number}) {
        const statusApi = ({offset, limit}: {offset: number, limit: number}) => <ExtendedRequestParams<
            DataFrom<AgentResponse<{items: InstallationStatus}>>>> {
            method: ['upgrading', 'status'],
            params: { offset, limit },
        };

        return this.xhr.rx(statusApi, false, false)({ offset, limit });
    }
}
